import React, { useEffect, useState } from "react";
import "./employeeList.css";
import strings from "../../utils/property-file/Employeedetails.json";
import SpinnerButton from "../button/spinnerButton";
import api from "../../services/api";
import {
  convertUtcToIst,
  extractTime,
  TimeDifferenceCalculator,
} from "../../utils/commonFunction/timeConvertor";
import moment from "moment";
import { toast } from "react-toastify";
import CheckoutModal from "./checkoutModal";

function EmployeeList() {
  const [isLoading, setIsLoading] = useState(true);
  const [employeeList, setEmployeeList] = useState([]);
  const [emptyMsg, setEmptyMsg] = useState("");
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [isCheckIn, setIsCheckIn] = useState(false);
  const [pendingUserId, setPendingUserId] = useState(null);
  const [selectedInTime, setSelectedInTime] = useState(null);

  useEffect(() => {
    getGeoLocation();
    getEmployeeList();
  }, []);

  const handleMarkAttendance = async (userId) => {
    console.log("handleMarkAttendance::",userId,);
    const currentDate = moment().format("YYYY-MM-DD");
    const employee = employeeList.find((emp) => emp.userId === userId);
    if (!employee) return;

    const isMarkingIn = !employee.isMarked;

    if (isMarkingIn) {
      const isEditable = JSON.parse(localStorage.getItem("isCheckInTimeEditable"));

      if (isEditable) {
        setPendingUserId(userId);
        setShowCheckoutModal(true);
        setIsCheckIn(true);
      } else {
        const inTime = new Date().toISOString();
        const payload = {
          userId,
          attendanceMarked: true,
          date: currentDate,
          inTime,
          latitude: location.latitude,
          longitude: location.longitude,
        };
        console.log("payload",payload);
        await markAttendanceAPI(payload);
      }
    } else {
      setPendingUserId(userId);
      setSelectedInTime(employee.inTime);
      setIsCheckIn(false);
      setShowCheckoutModal(true);
    }
  };

  const handleConfirmCheckout = (selectedTime) => {
    const currentDate = moment().format("YYYY-MM-DD");
    const employee = employeeList.find((emp) => emp.userId === pendingUserId);
    if (!employee) return;

    let outTime, inTime;
    if (selectedTime) {
      const timeOfNewDate = new Date(`${currentDate}T${selectedTime}:00`);
      const parsedTime = new Date(timeOfNewDate);
      const extractedTime = parsedTime.toTimeString().split(" ")[0];
      if (isCheckIn) {
        inTime = currentDate + "T" + extractedTime;
      } else {
        outTime = currentDate + "T" + extractedTime;
      }
    }

    const attendancePayload = {
      userId: employee.userId,
      attendanceMarked: isCheckIn ? true : false,
      date: currentDate,
      attendanceId: employee.attendanceId,
      latitude: location.latitude,
      longitude: location.longitude,
    };
    if (outTime) {
      attendancePayload.outTime = outTime;
    }
    if (inTime) {
      attendancePayload.inTime = inTime;
    }
    markAttendanceAPI(attendancePayload);
    setShowCheckoutModal(false);
    setPendingUserId(null);
  };

  useEffect(() => {
    if (location) {
      setLocation(location);
    }
  }, [location]);

  const getGeoLocation = async () => {
    try {
      if (!navigator.geolocation) {
        throw new Error("Geolocation is not supported by this browser.");
      }
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos),
          (err) => reject(new Error(`Geolocation error: ${err.message}`))
        );
      });

      const loc = {
        latitude: String(position.coords.latitude),
        longitude: String(position.coords.longitude),
      };
      setLocation(loc);
    } catch (error) {
      console.error("Error getting geolocation:", error.message);
    }
  };

  const getEmployeeList = async () => {
    try {
    
      const response = await api.fetchEmployeeList();
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success && data.body.length > 0) {
          const processedList = data.body.map((emp) => ({
            ...emp,
            isMarked: emp.inTime && !emp.outTime ? true : emp.outTime ? false : false,
          }));
          setEmployeeList(processedList);
        } else {
          setEmployeeList([]);
          setEmptyMsg(data.body);
        }
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message, { toastId: "error6" });
    }
  };

  const markAttendanceAPI = async (payload) => {
    try {
      const response = await api.markAttendance(payload);
      console.log("response::",response);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          toast.success(data.body, { toastId: "error14" });
          getEmployeeList();
        } else {
          toast.error(data.body, { toastId: "error6" });
        }
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message, { toastId: "error6" });
    }
  };

  const handleCancel = () => {
    setShowCheckoutModal(false);
  };

  return (
    <>
      <CheckoutModal
        show={showCheckoutModal}
        onConfirm={handleConfirmCheckout}
        onCancel={handleCancel}
        inTime={selectedInTime}
        isCheckin={isCheckIn}
      />

      <div className="search-bar">
        <input
          className="search-bar search-emp dashboard-search-bar"
          type="text"
          placeholder="Search..."
        />
      </div>

      <div>
        <div className="table-layout-mark-attendance mt-3 mx-auto table-data employee-attendance">
          <table className="table">
            <thead className="employee-status-header">
              <tr>
                <th scope="col">{strings.employeeId}</th>
                <th scope="col">{strings.employeeName}</th>
                <th scope="col">{strings.employeeType}</th>
                <th scope="col">{strings.status}</th>
                <th scope="col">{strings["check-in"]}</th>
                <th scope="col">{strings["check-out"]}</th>
                <th scope="col">{strings.duration}</th>
                <th scope="col">{strings.markAttendance}</th>
              </tr>
            </thead>
            {isLoading ? <tbody className="table-loader"><SpinnerButton/> </tbody>: <tbody className="employee-status-body">
               {employeeList.length > 0 ? (
                employeeList.map((item, index) => (
                  <tr key={index}>
                    <td>{item.employeeId}</td>
                    <td className="emp-name-field">{item.name}</td>
                    <td>{item.employmentType}</td>
                    <td
                      className="hint hint--right"
                      data-hint="Remote Location"
                    >
                      {item.attendanceStatus
                        ? item.workplace
                        : strings.emptyData}
                    </td>
                    <td>
                      {item.inTime
                        ? extractTime(convertUtcToIst(item.inTime))
                        : strings.emptyData}
                    </td>
                    <td>
                      {item.outTime
                        ? extractTime(convertUtcToIst(item.outTime))
                        : strings.emptyData}
                    </td>
                    <td>
                      {item.inTime && item.outTime ? (
                        <TimeDifferenceCalculator
                          time1={moment(item.inTime).format(strings.hhMMFormat)}
                          time2={moment(item.outTime).format(strings.hhMMFormat)}
                        />
                      ) : (
                        strings.emptyData
                      )}
                    </td>
                    <td>
                      <div className="toggle">
                        <label className="switch">
                          <input
                            type="checkbox"
                            onChange={() => {
                              console.log("ss",item.userId);
                              handleMarkAttendance(item.userId)
                            }}
                            checked={!!item.isMarked}
                          />
                          <span className="slider"></span>
                        </label>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    {emptyMsg}
                  </td>
                </tr>
              )}
            </tbody>
            } 
       
          </table>
        </div>
      </div>
    </>
  );
}

export default EmployeeList;

